import { IAppState } from '../../redux';

export function selectIsShortForm(state: IAppState): boolean {
  return state.layout.isShortForm;
}
